export const DESKTOP_HEADER_HEIGHT = 72;
export const MOBILE_HEADER_HEIGHT = 64;
export const MOBILE_NAVBAR_HEIGHT = 77;

export const DESKTOP_HEADER_ITEM_SPACING = 20;
